import spaceService from '../../services/spaceService';

const state = {
  spaces: [],
  loading: false,
  error: null
};

const getters = {
  allSpaces: state => state.spaces,
  activeSpaces: state => state.spaces.filter(space => space.active)
};

const actions = {
  async fetchSpaces({ commit }, filters = {}) {
    commit('SET_LOADING', true);
    try {
      const response = await spaceService.getSpaces(filters);
      console.log('Store received response:', response);
      if (response.success && response.data && response.data.data) {
        commit('SET_SPACES', response.data.data);
      } else {
        commit('SET_SPACES', []);
      }
      commit('SET_LOADING', false);
      return response;
    } catch (error) {
      console.error('Store error:', error);
      commit('SET_ERROR', error);
      commit('SET_LOADING', false);
      throw error;
    }
  },

  async addSpace({ dispatch }, spaceData) {
    try {
      const response = await spaceService.addSpace(spaceData);
      if (response.success) {
        await dispatch('fetchSpaces');
      }
      return response;
    } catch (error) {
      console.error('Error adding space:', error);
      throw error;
    }
  },

  async updateSpace({ dispatch }, { id, spaceData }) {
    try {
      const response = await spaceService.updateSpace(id, spaceData);
      if (response.success) {
        await dispatch('fetchSpaces');
      }
      return response;
    } catch (error) {
      console.error('Error updating space:', error);
      throw error;
    }
  },

  async deleteSpace({ dispatch }, spaceId) {
    try {
      const response = await spaceService.deleteSpace(spaceId);
      if (response.success) {
        await dispatch('fetchSpaces');
      }
      return response;
    } catch (error) {
      console.error('Error deleting space:', error);
      throw error;
    }
  }
};

const mutations = {
  SET_SPACES(state, spaces) {
    state.spaces = spaces;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}; 